<template lang="pug">
	
	.political-car
		.movable
			.car-background
				cover-image(src="assets/images/car-background.jpg")
			.car
				.car-container
					.car-body
						img(src="assets/images/car.png")
					.car-window
						img(src="assets/images/car-window.png")

					.car-wheel-left
						img(src="assets/images/wheel-left.png")

					.car-wheel-right
						img(src="assets/images/wheel-right.png")

</template>


<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import AssetsLoader from '../../../utils/assetsLoader.js'
	import Scrollable from '../../../abstracts/scrollable'
	import Globals from '~utils/Globals.js'
	import _ from 'lodash'

	import $ from 'jquery'
	import { TweenMax } from 'gsap'

	import CoverImage from '../../../components/images-elements/image-cover.vue'

	
  @Component({
		name: 'PoliticalCar',
		props: [],
		components: {CoverImage }
	})

	class PoliticalCar extends Scrollable {

		mounted () {
			super.mounted()

			this._dom()
			this.offset = 4000
		}

		init () {
			super.init()


		}

		_dom () {
			this.$movable = this.$el.querySelector('.movable')
			this.$window = this.$el.querySelector('.car-window')
			this.$windowEl = this.$window.querySelector('img')
			this.$car = this.$el.querySelector('.car-container')
			this.$wheelLeft = this.$el.querySelector('.car-wheel-left')
			this.$wheelRight = this.$el.querySelector('.car-wheel-right')
		}

		

		initTimeline () {
			super.initTimeline()

			const width = 1701
			const height = 1016

			const g_w = Globals.width

			this.$window.style.width = window.innerWidth * 211 / 1701 + "px"
			this.$window.style.height = window.innerWidth * 72 / 1440 + "px"
			this.$window.style.bottom = window.innerWidth * 306 / 1440 + "px"
			this.$window.style.left = window.innerWidth * 807 / 1440 + "px"

			this.$wheelLeft.style.width = window.innerWidth * 98 / 1440 + "px"
			this.$wheelLeft.style.left = window.innerWidth * 294 / 1440 + "px"
			this.$wheelLeft.style.bottom = window.innerWidth * 127 / 1440 + "px"

			this.$wheelRight.style.width = window.innerWidth * 93 / 1440 + "px"
			this.$wheelRight.style.left = window.innerWidth * 1082 / 1440 + "px"
			this.$wheelRight.style.bottom = window.innerWidth * 126	 / 1440 + "px"


			const totalHeight = window.innerHeight * 2 + this.offset
			const windowRatio = window.innerHeight / totalHeight
			
			this.tl.fromTo(this.$car,1/3,{x:g_w},{x:200,ease:Power0.easeNone},0)
			this.tl.to(this.$car,1/3,{x:-200,ease:Power0.easeNone},1/3)
			this.tl.to(this.$car,1/3,{x:-g_w,ease:Power0.easeNone},2/3)
			
			this.tl.fromTo(this.$windowEl,1/3,{y:'0%'},{y:'100%', ease:Power1.easeOut},1/3)
			
			this.tl.fromTo(this.$wheelLeft,1/3,{rotationZ:0},{rotationZ:-450,ease: Power0.easeNone},0)
			this.tl.to(this.$wheelLeft,1/3,{rotationZ:-630,ease: Power0.easeNone},1/3)
			this.tl.to(this.$wheelLeft,1/3,{rotationZ:-1080,ease: Power0.easeNone},2/3)

			this.tl.fromTo(this.$wheelRight,1/3,{rotationZ:0},{rotationZ:-450,ease: Power0.easeNone},0)		
			this.tl.to(this.$wheelRight,1/3,{rotationZ:-630,ease: Power0.easeNone},1/3)		
			this.tl.to(this.$wheelRight,1/3,{rotationZ:-1080,ease: Power0.easeNone},2/3)
			
			this.tl.fromTo(this.$movable,(1-windowRatio*2),{y:0},{y:this.offset, ease:Power0.easeNone},windowRatio)
		}

		raf (y) {
			super.raf(y)
		}

		_bind () {
			super._bind()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
		}

		_resize () {
			super._resize()

			this.bounds.height = window.innerHeight + this.offset
			this.$el.style.height = this.bounds.height + "px"

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.offset + window.innerHeight
			}


			this.initTimeline()
		}

	}

	export default PoliticalCar

</script>

<style lang="stylus" scoped>

	@import '../../../theme/variables'
	@import '../../../theme/utils'

	.political-car
		min-height 100vh
		width 100vw
		position relative
		overflow hidden
		z-index 60

		.movable
			height 100vh
			width 100vw
			position relative
			will-change transform	

		.car-background
			position relative
			z-index 30
			height 100vh
			width 100%

			img
				height 100%
				width 100%
				object-fit cover

		.car
			position absolute
			width 100%
			// max-width 1440px
			bottom 0
			left 50%
			transform translateX(-50%)
			z-index 40

		.car-body
			position relative
			bottom 0
			left 0
			z-index 40
			width 100%

			img
				height 100%
				width 100%
				object-fit cover

		.car-window
			position absolute
			bottom 306px
			left 807px
			width 178px
			height 72px
			overflow hidden
			z-index 50

			img
				width 100%
				transform translateY(0px)

		[class^="car-wheel"]
			position absolute
			bottom 50px
			left 100px
			z-index 50

			img
				width 100%

		.car-wheel-left
			bottom 100px




</style>


// WEBPACK FOOTER //
// political-car.vue?a0d1222a